<template>
  <main id="content" role="main">
    <!-- Page Header -->
    <div class="bg-primary" style="background-image: url(/themes/template/img/components/abstract-shapes-20.svg);">
      <div class="container space-2">
        <div class="row align-items-center">
          <div class="col">
            <div class="d-none d-md-block">
              <h1 class="h2 text-white">Assurez-vous que votre école est bien éligible à la taxe d’apprentissage !</h1>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="container space-top-1">
      <i class="fa fa-arrow-left text-primary" aria-hidden="true"></i>
      <a href="#">Retour</a>
    </div>


    <!-- Description Section -->
    <div class="container my-3">
      <div class="card">
        <div class="card-body">
          <!-- Form Group -->
          <div class="form-group col-lg-12" >
            <div class="col-lg-12">
              <h4 class="mb-4">Recherche Rapide</h4>
            </div>

            <div class="d-lg-flex align-items-end mx-0">
              <div class="col-lg-5">
                <label>Nom de l'école</label>
                <input v-model="nom_ecole" type="text" id="name" name="name" required
                       minlength="4" maxlength="8" size="10" class="form-control">
              </div>
              <div class="col">
                <p class="h2 text-center">OU</p>
              </div>
              <div class="col-lg-5">
                <label>Code UAI</label>
                <input v-model="code_uai" type="search" id="code-UAi" class="form-control">
              </div>

<!--              <div class="col">-->
<!--                <a href="./eligible.html" class="btn btn-soft-primary">Rechercher</a>-->
<!--              </div>-->
            </div>
          </div>
        </div>
        <!-- End Form Group -->
      </div>
    </div>

    <!-- Description Section -->
    <div v-if="eligible != -1" class="container  space-bottom-1">
      <div class="d-lg-flex">
        <div class="col-lg-6">
          <div class="card mb-3 mb-lg-5" :class="{'bg-success': eligible == 1}">
            <div id="eligible" class="card-body text-center text-light">
              <h3 class="mb-0" :class="{'text-light': eligible == 1, 'text-success': eligible == 0}">Vous êtes éligible</h3>
              <p v-if="eligible == 1" class="text-white h5">
                <a class="font-weight-bolder" href="./e-Pass-teacher/moncompte.html">
                  Compléter votre profil
                </a>
                  pour simplifier le processus de collecte de taxe.
              </p>
            </div>
          </div>
          </div>

        <div class="col-lg-6">
          <div class="card mb-3 mb-lg-5" :class="{'bg-danger': eligible == 0}">
            <div id="non_eligible" class="card-body text-center">
              <h3 class="mb-0" :class="{'text-danger': eligible == 1, 'text-light': eligible == 0}">Non Éligible</h3>
              <p v-if="eligible == 0" class="text-white h5">
                Vous n'êtes pas sur la liste des établissements éligibles à la taxe d'apprentissage. Cette taxe est
                accessible à tout organisme public qui propose, des alternances ou des stages d'entreprises. Pour plus
                d'information, référez-vous à la page <a class="text-warning" href="./faq.html">En savoir plus sur les taxes d'apprentissages</a></p>
            </div>
          </div> </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "DlnkTaxeEligibilite",

  watch: {
    nom_ecole: function(){
      //Empeche les interactions entre les 2 watch
      if(this.nom_ecole == "") {
        //On cache le bas si les 2 champs sont vides
        if (this.code_uai == "")
          this.eligible = -1;
        return;
      }

      //On vide l'autre champ
      this.code_uai = "";

      //Test temporaire
      this.eligible = (this.nom_ecole == "Ecole") ? 1 : 0;
    },

    code_uai: function(){
      //Empeche les interactions entre les 2 watch
      if(this.code_uai == "") {
        //On cache le bas si les 2 champs sont vides
        if(this.nom_ecole == "")
          this.eligible = -1;
        return;
      }

      //On vide l'autre champ
      this.nom_ecole = "";

      //Test temporaire
      this.eligible = (this.code_uai == "123456") ? 1 : 0;
    },
  },

  data: function () {
    return {
      eligible: -1,
      nom_ecole: "",
      code_uai: "",
    }
  }
}
</script>

<style scoped>

</style>